export const YES_NO = [
  { text: 'No', value: false },
  { text: 'Yes', value: true }  
]
